import React, { useEffect } from "react";
import format from "date-fns/format";
// import sign from "../assets/sign.jpg";
import sign2 from "../assets/sign2.jpg";
import "../printLandscape.css";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const Certificate = ({ certificate, admin, removeCertificate }) => {
  const formatDate = (date) => format(new Date(date), "MMM. dd, yyy");
  const formatDate2 = (date) => {
    const d = date.split("-");
    return `${months[Number(d[1]) - 1]}. ${d[2]}, ${d[0]}`;
  };
  return (
    <>
      {admin ? (
        <>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            data-bs-toggle="modal"
            data-bs-target={`#c-${certificate.id}`}
          >
            View
          </button>
          <button
            className="btn btn-sm btn-danger ms-2"
            onClick={() => removeCertificate(certificate.id)}
          >
            Remove
          </button>
        </>
      ) : (
        <button
          type="button"
          className="btn btn-outline-primary text-start m-1 p-3 d-print-none"
          data-bs-toggle="modal"
          data-bs-target={`#c-${certificate.id}`}
        >
          <h6 className="m-0">{certificate.exam}</h6>
        </button>
      )}
      <div className="modal fade" id={`c-${certificate.id}`} tabIndex="-1">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header container-lg d-print-none">
              <h5 className="modal-title" id="exampleModalLabel">
                Print Certificate
              </h5>
              <button
                className="btn btn-primary ms-auto px-4"
                onClick={() => {
                  document.title = `${certificate.exam} ${certificate.name}`;
                  window.print();
                }}
              >
                Print
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary ms-2"
                data-bs-dismiss="modal"
                onClick={() => (document.title = "CSRE")}
              >
                Close
              </button>
            </div>
            <div className="modal-body container-lg text-center">
              <div className="cer p-5">
                <div className="graphic"></div>
                <div className="graphic"></div>
                <div className="graphic"></div>
                <div className="graphic"></div>

                <h1 className="cer-heading">
                  <span>C</span>
                  <small>ERTIFICATE</small>
                  <small className="fst-italic"> of </small>
                  <span>C</span>
                  <small>OMPLETION</small>
                </h1>

                <h2 className="ff-tnr mb-0">COURSE TITLE:</h2>
                {/* <h4 className="ff-tnr mb-0">California Real Estate</h4> */}
                <h1 className="cer-title">{certificate.exam}</h1>
                <p>CalDRE Approval Number: {certificate.calBreNum}</p>

                <div className="mt-3">
                  <p className="mb-0 fst-italic fs-4">
                    Successfully completed the 45 hour correspondence home/study
                    course
                    <br />
                    and passed the final exam with a score of 60% or better.
                  </p>
                </div>
                <div className="mt-2">
                  <p className="m-0 ff-tnr fs-5">Issued to:</p>
                  <h1 className="ff-tnr fw-bold">{certificate.name}</h1>
                </div>
                <div className="mt-4 d-flex justify-content-between align-items-center fs-4 ff-tnr fw-bold">
                  <div className="text-start">
                    <p className="m-0 lh-sm">
                      Registration Date:{" "}
                      {formatDate2(certificate.registrationDate)}
                    </p>
                    <p className="m-0 lh-sm">
                      Date of Completion: {formatDate(certificate.creationDate)}
                    </p>
                    <p className="m-0 lh-sm">
                      Date of Issuance: {formatDate(certificate.creationDate)}
                    </p>
                  </div>
                  <div className="">
                    <p className="m-0 lh-sm">Verification of School Official</p>
                    {/* <p className="m-0 lh-sm">Sara Walker</p> */}
                    {/* <img src={sign} alt="Sara Walker" width={100} /> */}
                    <p className="m-0 lh-sm">Ken Elsner</p>
                    <img
                      src={sign2}
                      alt="Ken Elsner"
                      width={150}
                      style={{ filter: "contrast(1.2)" }}
                    />
                  </div>
                </div>
                {/* <img
                src={logo}
                alt="California School Of Real Estate"
                className="mt-5"
                height="150"
              /> */}
                <div className="mt-5 pt-5 ff-tnr">
                  <p className="fs-4 lh-sm m-0">
                    California School of Real Estate
                  </p>
                  <p className="fs-5 lh-sm m-0">
                    STATE HEADQUARTERS, 3160 Castro Valley Blvd., #231 Castro
                    Valley, CA 94546 (800)877-7008
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Certificate;
